<app-single #singleComponent [item]="photo" *ngIf="photo"></app-single>
